/** Lab tax settings returned by login and by update-tax-configuration. */

export const getLabTax = (lab) => {
  const saved =
    lab?.taxConfig && (lab.taxConfig.taxType || lab.taxConfig.taxAppliedTo)
      ? lab.taxConfig
      : lab || {};

  const taxType = String(saved.taxType || "gst").toLowerCase();
  const taxAppliedTo = ["test", "package", "both"].includes(saved.taxAppliedTo)
    ? saved.taxAppliedTo
    : "both";
  const enabled = taxType === "gst" || taxType === "vat";

  return {
    taxType: enabled ? taxType : "none",
    taxAppliedTo,
    enabled,
    label: taxType === "vat" ? "VAT" : taxType === "gst" ? "IGST" : "Tax",
  };
};

/** Keep login tax fields on the stored lab user, whether they sit on the user or beside it. */
export const withLoginTax = (user, responseData = {}) => {
  if (!user) return user;
  const taxType = user.taxType ?? responseData.taxType;
  const taxAppliedTo = user.taxAppliedTo ?? responseData.taxAppliedTo;
  return {
    ...user,
    ...(taxType != null ? { taxType } : {}),
    ...(taxAppliedTo != null ? { taxAppliedTo } : {}),
  };
};
